import { useQuery } from '@apollo/client';
import {
  NotificationsUnreadCountDocument,
  NotificationsUnreadCountQuery,
} from 'src/graphql/generated/graphql';

export const useUnreadNotificationsCount = (
  skip: boolean,
  onCompleted?: (data: NotificationsUnreadCountQuery) => void,
) => {
  const { data, loading } = useQuery<NotificationsUnreadCountQuery>(
    NotificationsUnreadCountDocument,
    {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-only',
      skip: skip,
      onCompleted,
    },
  );

  return {
    data: data?.getUnreadNotificationsCount,
    loading,
  };
};
